import ReactGA from "react-ga4";

ReactGA.initialize("G-DYXTDKR5ZP");

const useSendEventGA = () => {
  const sendEvent = (
    category,
    action,
    label,
    value,
    nonInteraction,
    transport
  ) => {
    ReactGA.event({
      category,
      action,
      label,
      value,
      nonInteraction,
      transport,
    });
  };

  return sendEvent;
};

export default useSendEventGA;
